var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectangle Copy 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Avenu---Visual-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.0-Providers",
    transform: "translate(-1182.000000, -4520.000000)",
    fill: "#D0EAE7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    x: 1182,
    y: 4520,
    width: 80,
    height: 80,
    rx: 40
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBlue);
export default __webpack_public_path__ + "static/media/light-blue.46ab2fef3075f4f20ca743b9ff9ee74e.svg";
export { ForwardRef as ReactComponent };